var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "camera_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 8.308,
    x: 3,
    y: 5.678,
    fill: "#fff",
    rx: 0.923
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.538,
    height: 3.692,
    fill: "#fff",
    rx: 0.923,
    transform: "matrix(1 0 0 -1 6.231 7.709)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.615,
    height: 4.615,
    x: 6.692,
    y: 7.523,
    fill: "#000",
    rx: 2.308
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h18v18H0z",
    mask: "url(#camera_svg__a)"
  })));
};
export default SvgCamera;